import React from 'react';
import { Card, CardTitle, CardText } from 'react-md';

import 'moment/locale/de';

import "./CardTotalAccessed.css"

export default ({accessCount}) => (
	<Card className="card-total-accessed">
		<CardTitle title="Anzahl der Abrufe"/>
		<CardText>
			{ accessCount }
		</CardText>
	</Card>
);


// WEBPACK FOOTER //
// ./src/components/summary/cards/CardTotalAccessed.jsx